import React, { useState } from 'react';
import supabase from '../../supabase/supabase';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export default function EditUserModal({ user, onClose, onSuccess }) {
  const [fullName, setFullName] = useState(user.full_name || '');
  const [role, setRole] = useState(user.role);
  const [avatarUrl, setAvatarUrl] = useState(user.avatar_url || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const { error: updateError } = await supabase
        .from('profiles_20240520')
        .update({ 
          full_name: fullName,
          role: role, 
          avatar_url: avatarUrl 
        })
        .eq('id', user.id);

      if (updateError) throw updateError;
      onSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[70] p-4 backdrop-blur-sm">
      <div className="bg-app-surface border border-app-border rounded-xl w-full max-w-md shadow-2xl overflow-hidden">
        <div className="p-6 border-b border-app-border flex justify-between items-center">
          <h2 className="text-xl font-bold flex items-center gap-2 text-white">
            <SafeIcon icon={FiIcons.FiEdit2} className="text-app-accent" />
            Edit User Profile
          </h2>
          <button onClick={onClose} className="text-app-muted hover:text-white"><FiIcons.FiX size={24}/></button>
        </div>

        <form onSubmit={handleUpdate} className="p-6 space-y-5">
          <div className="bg-app-bg px-4 py-3 rounded-lg border border-app-border">
            <p className="text-[10px] font-black uppercase tracking-widest text-app-muted mb-1">Account Email</p>
            <p className="text-sm font-mono text-white truncate">{user.email}</p>
          </div>

          <div className="space-y-1">
            <label className="text-[10px] font-black uppercase tracking-widest text-app-muted">Full Name</label>
            <input 
              type="text" 
              value={fullName}
              onChange={e => setFullName(e.target.value)}
              className="w-full bg-app-bg"
              placeholder="John Doe"
            />
          </div>

          <div className="space-y-1">
            <label className="text-[10px] font-black uppercase tracking-widest text-app-muted">System Role</label>
            <select 
              value={role}
              onChange={e => setRole(e.target.value)}
              className="w-full bg-app-bg"
            >
              <option value="user">Standard Trader</option>
              <option value="admin">Platform Admin</option>
            </select>
          </div>

          <div className="space-y-1">
            <label className="text-[10px] font-black uppercase tracking-widest text-app-muted">Avatar URL</label>
            <input 
              type="url" 
              value={avatarUrl}
              onChange={e => setAvatarUrl(e.target.value)}
              className="w-full bg-app-bg text-xs font-mono"
              placeholder="https://example.com/avatar.jpg"
            />
          </div>

          {error && (
            <div className="p-3 bg-app-red/10 border border-app-red/20 rounded text-app-red text-xs font-mono">
              {error}
            </div>
          )}

          <div className="pt-4 flex gap-3">
            <button 
              type="button" 
              onClick={onClose}
              className="flex-1 py-3 text-sm font-bold border border-app-border rounded-lg hover:bg-app-border transition-colors text-white"
            >
              Cancel
            </button>
            <button 
              type="submit"
              disabled={loading}
              className="flex-1 py-3 text-sm font-bold bg-app-accent text-black rounded-lg hover:bg-yellow-500 transition-colors flex items-center justify-center gap-2 shadow-lg"
            >
              {loading ? <FiIcons.FiLoader className="animate-spin" /> : <FiIcons.FiCheckCircle />}
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}